import { render, staticRenderFns } from "./Editar-Ocorrencia.vue?vue&type=template&id=72e4a54e&scoped=true&"
import script from "./Editar-Ocorrencia.vue?vue&type=script&lang=js&"
export * from "./Editar-Ocorrencia.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Ocorrencia.vue?vue&type=style&index=0&id=72e4a54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4a54e",
  null
  
)

component.options.__file = "Editar-Ocorrencia.vue"
export default component.exports